import { Controller } from "@hotwired/stimulus";

// Enables the YoY "Apply" button when Facility IDs or Matrix IDs and both years are set.
export default class extends Controller {
  static targets = ["facilityIds", "matrixIds", "year1", "year2", "submit"];

  connect() {
    this.syncSubmitState();
  }

  syncSubmitState() {
    if (!this.hasSubmitTarget) return;

    const enabled = this.isReady();
    this.submitTarget.disabled = !enabled;
    this.submitTarget.classList.toggle("cursor-not-allowed", !enabled);
    this.submitTarget.classList.toggle("opacity-60", !enabled);
    this.submitTarget.classList.toggle("hover:opacity-90", enabled);
  }

  isReady() {
    return (
      (this.facilityIdsValuePresent() || this.matrixIdsValuePresent()) &&
      this.year1ValuePresent() &&
      this.year2ValuePresent()
    );
  }

  facilityIdsValuePresent() {
    if (!this.hasFacilityIdsTarget) return false;
    return this.facilityIdsTarget.value.trim().length > 0;
  }

  matrixIdsValuePresent() {
    if (!this.hasMatrixIdsTarget) return false;
    return this.matrixIdsTarget.value.trim().length > 0;
  }

  year1ValuePresent() {
    if (!this.hasYear1Target) return false;
    return this.year1Target.value.trim().length > 0;
  }

  year2ValuePresent() {
    if (!this.hasYear2Target) return false;
    return this.year2Target.value.trim().length > 0;
  }
}
